export default __webpack_public_path__ + "static/media/patio-res6.a3f5e934.jpg";